import * as pdfjs from 'pdfjs-dist/build/pdf';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.min.js';

/**
 * @param {File} file
 * @return {Promise<Uint8Array>}
 */
const readFileAsUint8Array = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onload = () => {
      resolve(new Uint8Array(fileReader.result));
    };

    fileReader.onerror = (error) => {
      reject(error);
    };

    fileReader.readAsArrayBuffer(file);
  });
};

/**
 * @param {File} file
 * @param {string} [password]
 * @return {Promise<PDFDocumentProxy>}
 */
export const loadPdfFromFile = async (file, password) => {
  const data = await readFileAsUint8Array(file);

  return pdfjs.getDocument({ data, password }).promise;
};

/**
 * @param {string} url
 * @param {string} [password]
 * @return {Promise<PDFDocumentProxy>}
 */
export const loadPdfFromUrl = (url, password) => {
  return pdfjs.getDocument({ url, password }).promise;
};
